import { ref, type Ref } from "vue";
import { trackBehaviorEvent } from "~/core/utils/behaviorAnalytics";

export function useHeaderSearch(deps: {
  isExternalOverlayActive: Ref<boolean>;
}) {
  const { isExternalOverlayActive } = deps;

  const isSearchInFocus = ref<Boolean>(false);
  const searcInputValue = ref("");
  const desktopSearchRef = ref<HTMLElement | null>(null);
  const isSearchCantBeClosed = ref(false);

  const handleSearchResultMouseEnter = () => {
    isSearchCantBeClosed.value = true;
  };
  const handleSearchResultMouseLeave = () => {
    isSearchCantBeClosed.value = false;
  };

  const handleSearchInutChange = (keyword: string) => {
    searcInputValue.value = keyword;
  };

  const handleSearchFocus = () => {
    if (isExternalOverlayActive.value) {
      return;
    }

    if (!isSearchInFocus.value) trackBehaviorEvent("search_open");
    isSearchInFocus.value = true;
  };

  const handleSearchBlur = () => {
    isSearchInFocus.value = false;
  };

  return {
    isSearchInFocus,
    searcInputValue,
    desktopSearchRef,
    isSearchCantBeClosed,
    handleSearchResultMouseEnter,
    handleSearchResultMouseLeave,
    handleSearchInutChange,
    handleSearchFocus,
    handleSearchBlur,
  };
}
